import BaseScene from "@Scenes/BaseScene";

/*-------------- Config --------------------*/
import * as Scenes from '@Config/scenes';
import KeyCodes from '@Config/keycodes';

/*--------------- Game ---------------------*/
import Game from '@Game';

/**
 * Controls Scene
 * Handles creation of controls gui
 */
class LeftRightControls extends BaseScene
{
    private leftArrow: Phaser.GameObjects.Image;

    private rightArrow: Phaser.GameObjects.Image;

    /**
     * Contructor
     * @param name - key name of the scene
     */
    constructor()
    {
        super(Scenes.LEFT_RIGHT_CONTROLS);
    }

    /**
     * Enables input
     */
    protected create()
    {
        const gameSize = this.getGameSize();

        this.input.addPointer(2);
        this.input.on('pointerdown', this.onPointerDown.bind(this));
        this.input.on('pointerup', this.onPointerUp.bind(this));

        const leftArrow = this.add.image(200, gameSize.height - 100, 'left_arrow');
        const rightArrow = this.add.image(gameSize.width - 200, gameSize.height - 100, 'right_arrow');

        leftArrow.setScale(0.5);
        rightArrow.setScale(0.5);
        leftArrow.alpha = 0.1;
        rightArrow.alpha = 0.1;

        this.leftArrow = leftArrow;
        this.rightArrow = rightArrow;
    }


    /**
     * Callback for pointer down
     * @param pointer
     * @param gameObjects
     */
    protected onPointerDown(pointer: Phaser.Input.Pointer, gameObjects: Phaser.GameObjects.GameObject[])
    {
        const gameSize = this.getGameSize();

        const downX = pointer.downX;

        if (downX > gameSize.centerX)
        {
            this.rightArrow.alpha = 1;
            Game.freerider.setKeyDown(KeyCodes.LEAN_RIGHT[0]);
        }
        else
        {
            this.leftArrow.alpha = 1;
            Game.freerider.setKeyDown(KeyCodes.LEAN_LEFT[0]);
        }
    }

    /**
     * Callback for pointer up
     * @param pointer
     * @param gameObjects
     */
    protected onPointerUp(pointer: Phaser.Input.Pointer, gameObjects: Phaser.GameObjects.GameObject[])
    {
        const gameSize = this.getGameSize();

        const upX = pointer.upX;

        if (upX > gameSize.centerX)
        {
            this.rightArrow.alpha = 0.1;
            Game.freerider.setKeyUp(KeyCodes.LEAN_RIGHT[0]);
        }
        else
        {
            this.leftArrow.alpha = 0.1;
            Game.freerider.setKeyUp(KeyCodes.LEAN_LEFT[0]);
        }
    }

}

export default LeftRightControls;